// import { useRef } from "react";
import Image from '@/components/global/image';
import CloseIconV2 from '@/components/icons/CloseIconV2';
import { Fragment } from 'react';
// import { t } from "i18next";
// function getNextMonthIndex(currentMonthIndex) {
//   let nextMonthIndex = currentMonthIndex + 2;

//   if (nextMonthIndex <= 12) {
//     return nextMonthIndex;
//   } else if (nextMonthIndex === 13) {
//     return 0; // January
//   } else if (nextMonthIndex === 14) {
//     return 1; // February
//   }
// }

const MadfuWidgetModal = ({ t, locale, show, setShow }) => {
  const options = [
    {
      'title-ar': 'الشريعه السمحة:',
      'title-en': 'Add the item to your cart',

      'desc-ar': 'لا فوائد, ولا رسوم تأخير, ولا تكاليف مخفية',
      'desc-en': 'Add the item to your cart',
      img: 'shariah-compliant',
    },
    {
      'title-ar': 'معلومات البطاقة اّمنة بنسبة 100%:',
      'title-en': 'Fill in your details',

      'desc-ar': 'تنفيذ أمان قوي وحماية.',
      'desc-en': 'Add the item to your cart',
      img: 'cards-secure',
    },
    {
      'title-ar': 'استمتع الاّن, وادفع لاحقا:',
      'title-en': 'Select MADFU at checkout',

      'desc-ar': 'بدون فوائد, وبدون رسوم تأخير, وبدون تكاليف مخفية',
      'desc-en': 'Add the item to your cart',
      img: 'pay-later',
    },
  ];

  return (
    <Fragment>
      {show ? (
        <div className='fixed left-1/2 top-1/2 z-[999999] flex w-screen max-w-[900px] -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center gap-6 overflow-auto overflow-x-hidden rounded-xl bg-gray-100 p-8 text-center shadow-lg sm:h-[80vh] sm:w-[90vw] md:h-[614px] md:max-h-[48vh] md:w-8/12 md:justify-between'>
          <CloseIconV2
            onClick={() => setShow(false)}
            className='absolute start-4 top-4 cursor-pointer'
          />
          <p className='mx-4 mt-10 w-full border-b-[0.5px] border-gray-300 pb-5 text-center text-lg md:text-right'>
            <span className='font-bold'>{t('Split into Payments')}</span>{' '}
            <span>{t('Split up to 6 Payments')}</span>
          </p>
          <p className='mx-4 w-full border-b-[0.5px] border-gray-300 pb-5 text-center text-lg md:text-right'>
            <span className='font-bold'>{t('Monthly payments')}</span>{' '}
            <span>{t('With no interest, no late fees & no hidden costs')}</span>
          </p>
          <div className='w-full bg-gray-100'>
            <div className='grid grid-cols-1 gap-6 md:grid-cols-3'>
              {options?.map((opt) => (
                <div
                  key={`madfu-widget-modal-${opt.icon}`}
                  className='flex flex-col items-center md:items-start'
                >
                  <Image
                    loading='eager'
                    priority='high'
                    src={`/imgs/madfu/new/${opt.img}.png`}
                    alt={opt['title-' + locale]}
                    className='h-20 object-contain'
                  />
                  <p className='text-base font-bold'>
                    {opt['title-' + locale]}
                  </p>

                  <p className='text-base'>{opt['desc-' + locale]}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </Fragment>
  );
};

export default MadfuWidgetModal;
